import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const postApi = createAsyncThunk(
    'auth/posts',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.postsList, { params: data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }

const postSlice = createSlice({
    name: 'post list',
    initialState: intialState,
    reducers: {
        resetPost: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(postApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(postApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(postApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const { resetPost } = postSlice.actions
export const postReducer = postSlice.reducer